import { useRoutes } from "react-router-dom";
import routes from "./routes";

const Route = () => useRoutes(routes);

export default Route;
